import React from "react";
import { t } from "../../../components/CustomComponent.js";
import HomeMedia from "./HomeMedia.js";
import HomeFav from "./HomeFav.js";
import HomeCardContact from "./HomeCardContact.js";
import ICON from "../icons.js";
import { homeStatusMeta } from "../options.js";

/* ============================================================================
 * PropertySimilar — "ทรัพย์ใกล้เคียง" ท้ายหน้ารายละเอียด
 * ใช้การ์ดชุดเดียวกับหน้าแรก (.hm-card) เพื่อให้ผู้ใช้จำรูปแบบได้ทันที
 * รวมถึงแถวปิดท้าย (HomeCardContact) ที่เป็นปุ่มโทร/LINE เหมือนการ์ดที่อื่น
 * ========================================================================== */
export default function PropertySimilar({ items = [], favorites = {}, fav_pop, onFavorite, onOpen, onViewAll }) {
  if (!items.length) return null;

  return (
    <section className="hm-section hm-section--soft hm-pd-similar">
      <div className="hm-container">
        <div className="hm-section__head">
          <div>
            <h2 className="hm-section__title">{t("detail_similar_title")}</h2>
            <p className="hm-section__desc">{t("detail_similar_desc")}</p>
          </div>
          <button type="button" className="hm-section__link" onClick={onViewAll}>
            {t("view_all")}
            <span className="hm-ico">{ICON.chevron_right}</span>
          </button>
        </div>

        <div className="hm-grid">
          {items.map((item) => {
            const isLand = item.type === "land";
            const status = homeStatusMeta(item.status);
            return (
              <article key={item.id} className="hm-card" onClick={() => onOpen && onOpen(item)}>
                <div className="hm-card__media">
                  <HomeMedia src={item.src} kind={item.kind} tone={item.tone} ratio={0.66} alt={item.name} />
                  {/* ป้ายสถานะจริงของทรัพย์ (ว่าง / ติดจอง / ขายแล้ว) ชุดเดียวกับการ์ดที่อื่น
                      — เดิมที่นี่อ่าน item.badge / item.badge_color ซึ่งเป็นฟิลด์ของ "การ์ด
                      โครงการ" ทรัพย์ไม่มีส่งมา ป้ายใบแรกจึงกลายเป็นกล่องเปล่าสีเข้มทุกใบ */}
                  <div className="hm-card__badges">
                    <span className={`hm-badge hm-badge--${status.color}`}>{t(status.label)}</span>
                    <span className="hm-badge hm-badge--light">
                      {t(item.deal === "rent" ? "home_deal_rent" : "home_deal_sale")}
                    </span>
                  </div>
                  <HomeFav
                    active={!!favorites[item.id]}
                    pop={fav_pop === item.id}
                    onClick={() => onFavorite(item.id)}
                  />
                </div>

                <div className="hm-card__body">
                  <div className="hm-card__price">
                    {item.price_text}
                    {item.price_unit && <span>{t(item.price_unit)}</span>}
                  </div>
                  <h3 className="hm-card__title">{item.name}</h3>
                  <div className="hm-card__loc">
                    <span className="hm-ico">{ICON.marker}</span>
                    {item.zone}
                  </div>

                  <div className="hm-card__specs">
                    {isLand ? (
                      <span className="hm-card__spec">
                        <span className="hm-ico">{ICON.area}</span>
                        {item.area.toLocaleString()} {t("home_unit_sqw")}
                      </span>
                    ) : (
                      <>
                        <span className="hm-card__spec">
                          <span className="hm-ico">{ICON.bed}</span>
                          {item.bed} {t("home_unit_bed")}
                        </span>
                        <span className="hm-card__spec">
                          <span className="hm-ico">{ICON.bath}</span>
                          {item.bath} {t("home_unit_bath")}
                        </span>
                        <span className="hm-card__spec">
                          <span className="hm-ico">{ICON.area}</span>
                          {item.area} {t("home_unit_sqm")}
                        </span>
                      </>
                    )}
                  </div>
                </div>

                {/* ผู้ติดต่อของประกาศ — ชุดเดียวกับ "ทรัพย์แนะนำ" และ "โครงการ"
                    (เดิมที่นี่เป็นชื่อผู้ดูแล + รหัสทรัพย์แบบตัวหนังสือล้วน) */}
                <HomeCardContact contact={item.contact} />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
